import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoggerService } from 'app/shared/services/logger.service';
import { SessionService } from 'app/shared/services/session.service';

@Component({
  selector: 'is-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss'],
  standalone: false
})
export class DocumentUploadComponent implements OnInit {
  @Input() claimNumber!: string;
  @Input() useCaching!: boolean;
  @Output() refreshRequired = new EventEmitter<void>();

  uploadCompleteEmitter = new EventEmitter<any>();
  fileUploaded: boolean = false;
  claimDetails: any;
  private policyNumber: string;
  private contactPublicId: string;
  private userType: string;

  private static readonly LOG_PREFIX = 'DocumentUploadComponent';

  constructor(
    private logger: LoggerService,
    private sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.initializeLogger();
    this.initializeSessionData();

    this.uploadCompleteEmitter.subscribe((data) => {
      if (data.item_status) {
        this.logger.info('Property Tracker File uploaded successfully.');
        this.fileUploaded = true;
      } else if (data.error) {
        this.logger.info('Property Tracker File upload failed.');
        this.logger.info('File upload error', data.error);
        this.fileUploaded = false;
      }
    });
  }

  refreshDocuments(): void {
    this.logger.info('Refresh requested from DocumentUploadComponent');
    this.refreshRequired.emit();
  }
  private initializeLogger(): void {
    this.logger.setComponentName('DocumentUploadComponent');
    this.logger.setPageName('Document Upload');
    this.logger.info(`${DocumentUploadComponent.LOG_PREFIX} - Component Initialized`, {
      claimNumber: this.claimNumber,
      policyNumber: this.policyNumber,
      userType: this.userType
    });
  }

  private initializeSessionData(): void {
    if (!this.claimNumber) {
      this.claimNumber = this.sessionService.getClaimNumber();
    }
    this.contactPublicId = this.sessionService.getSessionItem('claimsContactPublicId');
    this.policyNumber = this.sessionService.getPolicyNumber();
    this.userType = this.sessionService.getUserType();
  }
}
